module.exports = __webpack_public_path__ + "img/img-4693b4.png";